<template>
  <v-container class="ml-0">
    <v-row>
      <v-col cols="12">
        <Form
          dispatch="projectStore/create"
          button_title="create"
          button_icon="mdi-plus"
        ></Form>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Form from "./FormProject.vue";
import { permissions } from "../mixins/permissions";
export default {
  name: "EditProject",
  mixins: [permissions],
  components: {
    Form
  }
};
</script>

<style scoped></style>
